import React from 'react';
import ForgotPasswordForm from '../components/ForgotPasswordForm/ForgotPasswordForm';
import logo from '../assets/logo.svg';

const Fullscreen = () => (
  <div className="container-fluid">
    <div className="row min-vh-100">
      <ForgotPasswordForm
        heading="Reset Password"
        subheadingColor="#6b6b6b"
        subheading="Enter your email and we'll send you a link to reset your password"
        helpText="If an account exists for this email address, you will be sent a link to reset your password."
        image={logo}
        backgroundColor="#f3f3f3"
      />
    </div>
  </div>
);

export default Fullscreen;
